import { JobRequest } from "../../entities/JobRequest";
import { Helpers } from "../../../jobs-flow/Helpers";
import { Invoice } from "../../entities/Invoice";

export const QuoteInvoiceFormInterface = {

    checkAdditionalFields() {
        const formId = this.form.getAttribute('id');
        this.addCalculateListners();
        this.calculateTotalPriceInForm(null, formId.replace('-container', ''));
        Helpers.checkAdditionalAttributes();
    },

    showRequestInfo(e) {
        const form = $(e.target).parents('.form-container').find('form');

        if(!$('#request-detals').html()) {
            const requestId = form.find('input[name=job_request_id]').val();
            const request = new JobRequest(requestId);
            const formHTML = request.getForm('request', 'view');
            request.pasteForm(formHTML, 'request-detals');

            const requestForm = $('#request-detals').find('.modal');
            requestForm.removeClass('fade');
            requestForm.removeClass('modal');
            requestForm.css('display', 'block');
            requestForm.find('.close-btn, .modal-btn').remove();

            request.completeForm('view-request');
        }

        if ($('#request-detals').css('width') == '550px') {
            $('#request-detals').css({'width': '0px', 'margin-right': '-5px'});
        } else {
            $('#request-detals').css({'width': '550px', 'margin-right': '20px'});
        }
    },

    addCalculateListners() {
        $('input.calculable').off();
        $('input.calculable, input[type=checkbox]').on('change', (e) => {
            this.duplicateInput(e)
            this.calculateTotalPriceInItem(e);
            this.calculateTotalPriceInForm(e);
        });
        $('input').on('input', (e)=>{
            this.duplicateInput(e)
        })
        $('input.calculable').on('input', (e) => {
            this.duplicateInput(e)
            this.calculateTotalPriceInItem(e);
            this.calculateTotalPriceInForm(e);
        });
    },

    duplicateInput(event){
        const root = $(event.target).parents('.item');
        const parent = $(event.target).parents('.item-section');
        if(root?.length && parent?.length && (event.target?.name || event.target?.id)){
            const selector = 'input'+event.target?.name ? `[name=${event.target?.name}]` : `#${event.target?.id}`
            const doubleInput = $(root.find(`.item-section`).not(parent)).find(selector);
            if(!doubleInput)
                return
            if(event.target.type == 'checkbox'|| event.target.type=='radio'){
                doubleInput.prop('checked', event.target.checked)
            }else{
                doubleInput.val($(event.target).val())
            }
        }
    },

    addAnotherLine(formId) {
        const lastItem = $(`#${formId}`).find('.item').last();
        const lastIndex = parseInt(lastItem.attr('id').split('_').pop()) + 1;

        $(`#${formId}`).append(window.formLine);
        $(`#${formId}`).find('.item').last().prop('id', `item_${lastIndex}`);
        this.addCalculateListners();


        if($(`#${formId}`).find('.item').length != 1) {
            $(`#${formId}`).find('.item').find('.remove-line').removeClass('unvisible');
        } else {
            $(`#${formId}`).find('.item').first().find('.remove-line').addClass('unvisible');
        }
    },
    removeLine(target) {
        const formId = $(target).parents('form').attr('id');
        $(target).parents('.item').remove();

        if($(`#${formId}`).find('.item').length == 1) {
            $(`#${formId}`).find('.item').first().find('.remove-line').addClass('unvisible');
        }
        this.calculateTotalPriceInForm(null, formId);
    },
    calculateTotalPriceInItem: (event) => {
        const parent = $(event.target).parent().parent();
        let cost = parent.find('input.cost-input').val();
        if(!!cost) cost = parseFloat(cost.replace('$', '')).toFixed(2);
        else return;
        const quantity = parent.find('input.quantity-input').val();
        if (typeof(quantity) == "undefined") return;
        const taxable = parent.find('input[name=taxable]');

        const tax = taxable ? parent.find('input[name=tax]').val() / 100 : 0;
        const basePrice = cost * quantity;
        const allPrice = basePrice * (1 + tax);

        parent.find('.price').text(`$${(allPrice).toFixed(2)}`);
    },
    calculateTotalPriceInForm: (event, formId=null) => {
        if(!formId) formId = $(event.target).parents('form').attr('id');

        const itemRows = $(`#${formId} .item`);

        let subTotalPrice = 0;
        let tax = 0;

        for (let itemRow of itemRows) {
            itemRow = $(itemRow);
            let cost = itemRow.find('input.cost-input').val();
            if(!!cost) cost = parseFloat(cost.replace('$', '')).toFixed(2);
            else return;
            const quantity = itemRow.find('input.quantity-input').val();
            if (typeof(quantity) == "undefined") return;
            const taxable = itemRow.find('input[name=taxable]').is(':checked');

            if (!taxable) {
                itemRow.find('[name=tax]').val('');
                itemRow.find('[name=tax_id]').val('');
            }

            const itemTax = taxable ? itemRow.find('input[name=tax].calculable')[1].value / 100 : 0;
            subTotalPrice += cost * quantity;
            tax += cost * quantity * itemTax;
        }

        $(`#${formId}-container .output .sub-total .value`).text(`$${subTotalPrice.toFixed(2)}`);
        $(`#${formId}-container .output .tax .value`).text(`$${tax.toFixed(2)}`);
        $(`#${formId}-container .output .total .value`).text(`$${(subTotalPrice + tax).toFixed(2)}`);
    },

    collectDataInForm: (formId) => {

        let data = {
            items: [],
            job_request_id: $('[name=job_request_id]').val(),
            id: $('.entity_id').val()
        }

        const items = $(`#${formId} .item`);
        for (let item of items) {
            const itemJQ = $(item);
            let itemData = {
                id: itemJQ.find(`input[name=item_id]`).val(),
                item: itemJQ.find(`input[name=item]`).val(),
                details: itemJQ.find(`textarea[name=details]`).val(),
                quantity: itemJQ.find(`input[name=quantity]`).val(),
                cost: itemJQ.find(`input[name=cost]`).val(),
            }
            const taxable = itemJQ.find(`input[type=checkbox]`)[0].checked;
            itemData.tax_id = taxable ? itemJQ.find(`input[name=tax_id]`).val() ?? null : null,
            data.items.push(itemData);
        }

        $('input[name=expiration_date]').length && (data.expiration_date = $('input[name=expiration_date]').val());
        $('input[name=down_payment]').val() && (data.down_payment = $('input[name=down_payment]').val());
        $('input[name=start_date_time]').length && (data.start_date_time = $('input[name=start_date_time]').val());
        $('input[name=due_days]').val() && (data.due_days = $('input[name=due_days]').val());
        $('input[name=late_fee_percent]').val() && (data.late_fee_percent = $('input[name=late_fee_percent]').val());
        $('input[name=quote_id]').val() && (data.quote_id = $('input[name=quote_id]').val());
        $('input[name=completion_date]').length && (data.completion_date = $('input[name=completion_date]').val());

        if (!data.job_request_id) {
            data.customer_id = $('[name=customer_id]').val();
            data.service_id = $('[name=service_id]').val();
        }

        return data;
    },

    preview(formId) {
        const data = this.collectDataInForm(formId);
        const params = btoa(JSON.stringify(data));
        const entityClass = formId.split('-')[1];
        const previewUrl = `/jobs-flow/${entityClass}/preview`;

        $.ajax({
            url: previewUrl,
            method: 'POST',
            data: { data: params },

            success: (response) => {
                localStorage.setItem(`${entityClass}_preview_data`, response);
                window.open(previewUrl, '_blank');
            }
        })

    },
}
